export default __webpack_public_path__ + "static/media/screen5.cf114411.png";